import axiosInstance from "./axiosInstance";

export const getOfferCountdownSetting = async () => {
  const { data } = await axiosInstance.get("/settings/offer");
  return data;
};
